// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1pQV1","label":"CategoryService_label__Kt1sR","location":"CategoryService_location__3TQ8-"};